import flagArgentina from 'assets/images/icons/flag-argentina.svg';
import flagIndia from 'assets/images/icons/flag-india.svg';

import { GeoValue } from '../slice';

export interface IGeo {
  value: GeoValue;
  label: string;
  icon: string;
}

export const GEO_OPTIONS: IGeo[] = [
  { value: 'inr', label: 'India', icon: flagIndia },
  { value: 'ars', label: 'Argentina', icon: flagArgentina },
];
